var viLang = {
	"Sử dụng số điện thoại để Đăng nhập hoặc Đăng ký tài khoản của bạn": "Sử dụng số điện thoại để Đăng nhập hoặc Đăng ký tài khoản của bạn",
	"Vui lòng nhập số OTP đã được gửi về số điện thoại {{phone}} để thực hiện đăng nhập": "Vui lòng nhập số OTP đã được gửi về số điện thoại {{phone}} để thực hiện đăng nhập",
	"Đã gửi mã OTP": "Đã gửi mã OTP",
	"Đã gửi lại mã OTP": "Đã gửi lại mã OTP",
	"Nhập số điện thoại": "Nhập số điện thoại",
	"Gửi": "Gửi",
	"Gửi lại mã": "Gửi lại mã",
	"Gửi lại mã sau {{countDownTime}}s": "Gửi lại mã sau {{countDownTime}}s",
	"Bạn đã yêu cầu OTP vượt quá số lần quy định": "Bạn đã yêu cầu OTP vượt quá số lần quy định"
};

export { viLang as default };
